import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  NoteAdd as NoteAddIcon,
  Update,
  Timeline,
  Visibility,
  Delete,
  ShareOutlined as ShareIcon
} from '@mui/icons-material';

const LeadsActionMenu = ({
  onAddNote,
  onUpdateStatus,
  onView,
  onDelete,
  onShareProperties,
  children,
  currentStage = null
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    // Prevent the click from bubbling up to the row
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleAction = (action, event) => {
    if (event) {
      event.stopPropagation();
    }
    handleClose();
    if (typeof action === 'function') {
      action(event);
    }
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label="more actions"
        aria-controls={open ? 'lead-action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
          },
          transition: 'all 0.2s'
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      
      <Menu
        id="lead-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: '200px',
            marginTop: '4px',
            padding: '4px 0',
            borderRadius: '8px',
            boxShadow: '0px 4px 12px rgba(0,0,0,0.15)'
          }
        }}
      >
        {/* Highest priority action - View Details */}
        {/* <MenuItem
          onClick={(e) => handleAction(onView, e)}
          sx={{ 
            py: 1.2,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '& .MuiListItemIcon-root': { 
              color: 'primary.main',
              minWidth: 'auto', 
              mr: 1.5
            }
          }}
        >
          <ListItemIcon>
            <Visibility fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View Details" />
        </MenuItem> */}

        {/* Second priority - Add Notes */}
        <MenuItem
          onClick={(e) => handleAction(onAddNote, e)}
          sx={{ 
            py: 1.2,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '& .MuiListItemIcon-root': { 
              color: 'success.main',
              minWidth: 'auto', 
              mr: 1.5
            }
          }}
        >
          <ListItemIcon>
            <NoteAddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Add Notes" />
        </MenuItem>

        {/* Third priority - Update Status */}
        <MenuItem
          onClick={(e) => handleAction(onUpdateStatus, e)}
          sx={{ 
            py: 1.2,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '& .MuiListItemIcon-root': { 
              color: currentStage === 'junk' ? 'success.main' : 'info.main',
              minWidth: 'auto', 
              mr: 1.5
            }
          }}
        >
          <ListItemIcon>
            <Update fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary={currentStage === 'junk' ? "Move back to Qualified" : "Update Stage/Status"} 
          />
        </MenuItem>

        {/* Share Properties */}
        {/* <MenuItem
          onClick={(e) => handleAction(onShareProperties, e)}
          sx={{ 
            py: 1.2,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '& .MuiListItemIcon-root': { 
              color: 'warning.main',
              minWidth: 'auto', 
              mr: 1.5
            }
          }}
        >
          <ListItemIcon>
            <ShareIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Share Properties" />
        </MenuItem> */}

        {/* Custom child menu items */}
        {children}

        {/* Lowest priority - Delete */}
        <MenuItem
          onClick={(e) => handleAction(onDelete, e)}
          sx={{ 
            py: 1.2,
            color: 'error.main',
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.04)',
            },
            '& .MuiListItemIcon-root': { 
              color: 'error.main',
              minWidth: 'auto', 
              mr: 1.5
            },
            '& .MuiListItemText-primary': {
              color: 'error.main'
            }
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default LeadsActionMenu;
